import MuiBox, { BoxProps } from '@mui/material/Box';

function Box(props: BoxProps) {
  return <MuiBox {...props} />;
}

export default Box;
